<template>
<diV>


  <van-popup v-model="$store.state.shareShow" round position="bottom" :style="{ height: '20%' }">

    <div class="share">

      <div v-for="(item,index) in $store.state.shareMenu" class="shareMenu" @click="$toast('第三方功能接入中，敬请期待');">
        <div class="shareMenuCircular" :style="'background-color:' + item.backgroundColor">
          <svg-icon :icon-class="item.icon" :style="item.style"/>
        </div>

        <div class="shareText">{{item.title}}</div>
      </div>


    </div>

  </van-popup>


</diV>
</template>

<script>
export default {
  name: "share"
}
</script>

<style scoped>

</style>